(function () {
	'use strict';

	angular.module('widgets.supplychain')
	.service('lateDeliveryCausesService', lateDeliveryCausesService);

	lateDeliveryCausesService.$inject = ['$http', 'tableService'];

	function lateDeliveryCausesService($http, tableService) {
		return {
			getChartData: getChartData
		};

		function getChartData(filterService) {
			var factoryNdxString = filterService.getFactoryList();
			var url = '/api/2/factndx/' + factoryNdxString;
			url += '/LateDeliveryCauses';
			url = addQueryParam(url,
				filterService.getFactoryList(), filterService.getQueryParamsObject(true), false);

			tableService.trackPageView('late-delivery-causes', factoryNdxString);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}
	}
})();
